export const additionalSounds = [
    {
        src: "sounds/bird.mp3",
        id: "bird",
    },
];
